import React, { useEffect } from 'react'
import { SearchContainer } from '../../dashboard/subContent/searchContainer/SearchContainer'
import useSearchMember from '../../../hooks/fetchUsers'
import { useSelector } from 'react-redux'
import { AdminLogsTable } from './AdminLogsTable'
import { logsSearchSchema } from './LogsSearchSchema'




export const AdminLogs = () => {

const initialParams= {
  $type: "logs",
  pageIndex: 1,
  pageSize: 10,
  sortBy: "",
  sortDir: "",
  username: "Admin",
  logDate: "",
  transactionType: undefined
}

    const URL = 'Transactions'
    const { renderUsers, handleObject, loading, customData } = useSearchMember(URL,initialParams)

    useEffect(() => {
        document.title = 'TPA® Admin - Emails'
    }, [])
    return (
        <>

            <SearchContainer 
            searchSchema={logsSearchSchema}
            />


            <AdminLogsTable
                currentPagination={customData.current}
                usersData={renderUsers}
                handleObject={handleObject}
                loading={loading}
                memberShip={false} //👉 activa el modal de informacion del miembro
                alert={false} //👉 activa el modal de alerta de acciones 
            />

        </>
    )
}
